// extracted by mini-css-extract-plugin
export default {"numOfOtpsInput":"b7jAg","otp":"ywOEW","title":"nHK2h","button":"_d4JC","container":"A_jAU","separator":"fGUN2","inputs":"uhZvT","buttonContainer":"xgb9P"};